import React, { useCallback, useEffect, useRef } from 'react';

import logo from './assets/images/i.jpg';

const isSafariOnIphone = () => {
  const ua = navigator.userAgent;
  const isIos = /iPad|iPhone|iPod/.test(ua);
  const isSafari = /^((?!chrome|android|fxios|crios|edgios).)*safari/i.test(ua);
  return isIos && isSafari;
};

function App({
  webBaseUrl = 'https://web.max.ru',
  appBaseUrl = 'https://max.ru',
  botName = 'id5610212189_3_bot',

  appScheme = 'max://max.ru',
  webUrl = 'https://web.max.ru',
  fallbackUrl,
}) {
  const handleClick = () => {
    // Для Safari на iPhone — всегда веб-версия
    const url = isSafariOnIphone()
      ? `${webBaseUrl}/${botName}`
      : `${appBaseUrl}/${botName}`;
    window.location.href = url;
  };

  const timerRef = useRef(null);

  const handleOpenApp = useCallback(() => {
    // Формируем ссылку для попытки открыть приложение
    const appLink = `${appScheme}/${botName}`;
    // Запасная ссылка на веб-версию
    const webLink = `${webUrl}/${botName}`;

    // Пытаемся открыть приложение
    window.location.href = appLink;

    // Если через 2.5 секунды приложение не открылось, переходим в веб
    timerRef.current = window.setTimeout(() => {
      window.location.href = fallbackUrl || webLink;
    }, 1500);
  }, [botName, appScheme, webUrl, fallbackUrl]);

  // Очищаем таймер при размонтировании, чтобы избежать утечек
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return (
    <div className="app-container">
      <main className="main-content">
        <div className="card">
          {/* Желтая иконка (замените на свой SVG/PNG) */}
          <div className="card-icon">
            <img src={logo} alt="" />
          </div>

          <h1 className="card-title">Онлайн-интерактивы</h1>
          <p className="card-handle">@id5610212189_3_bot</p>
          <p className="card-description">
            Онлайн-интерактивы для зрителей трансляции
          </p>

          <button className="start-btn" onClick={handleOpenApp}>
            Запустить бота
          </button>

          <p className="card-note">
            Если у вас установлено приложение MAX, можно сразу запустить бота
          </p>
        </div>
      </main>
    </div>
  );
}

export default App;
